import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {cloudLight} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    marginTop: indent,
    paddingBottom: 15,
  },
  bottom: {
    paddingTop: 15,
    borderTopWidth: 1,
    borderTopColor: cloudLight,
  },
});
